/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useLayoutEffect, useRef } from 'react';
import {
  TableUnit,
  TableHead,
  TableSubHeader,
  TableHeader,
  TableTopHeader,
  TableTopHeaderSub,
  TableBody,
  TableRow,
  SortArrow,
  SortPopUp,
  ArrowUp,
  RadiosContainer,
  CheckBoxWrapper,
  PopUpText,
  TableColumn,
  ColumnContainerSummary,
  ArrowHolderSummary,
  StickyTableHeadDate,
  FeatureLocked,
  TitleFeatureLocked
} from './styles';
import { InputErasableContainer, InputErasableField, InputErasableDelete } from './styles';
import { Radio, InputCheckbox, SelectPlayerColumn } from '..';
import Utils, { deepGet } from '../../utils/api/Utils';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import getFatigueZoneBullet from '../../utils/hooks/fatigue-zone-bullet';
import { GoChevronDown, GoChevronUp } from 'react-icons/go';
import Loader from '../loader/loader';
import TooltipFatigueZones from '../TooltipFatigueZones/TooltipFatigueZones';
import { ArmRecovery, ArmStrength, ShoulderBalance, StrengthVelocityRatio } from '../../utils/constants/fatigueZonesInfo';
import { Oval } from '../../pages/players/styles';
import { toast } from 'react-toastify';
import { handleDate } from '../../utils/helpers/handleDate';

function PopUp({
  table,
  useTable,
  data,
  visible,
  popup_id,
  includeAlerts,
  status,
  medical,
}: {
  table: Array<any>;
  useTable: any;
  data: Array<string>;
  visible: string;
  popup_id: string;
  includeAlerts?: boolean;
  status?: Array<string>;
  medical?: boolean;
}) {
  const UTILS = new Utils();
  const [reverse, useReverse] = useState<boolean>(true);
  const sortOptions = [reverse, useTable, table];
  const [firstRender, useFirstRender] = useState<boolean>(true);
  const [radio, useRadio] = useState<any>({ one: false, two: false });
  const [check, useCheck] = useState<any>({ zone_1: false, zone_2: false, zone_3: false });

  useEffect(() => {
    if (!firstRender) {
      UTILS.HandleSorted(data, sortOptions);
    } else {
      useFirstRender(!firstRender);
    }
    if (status) buildFilter();
  }, [radio]);

  useEffect(() => {
    if (status) buildFilter();
  }, [check]);

  function buildFilter() {
    let filters: Array<string> = [];
    Object.values(check).map((item, idx) => {
      if (item) {
        filters.push(Object.keys(check)[idx]);
      }
      return item;
    });
    filters = filters.map(item => {
      if (item === 'zone_1') {
        item = 'zone 1';
      }
      if (item === 'zone_2') {
        item = 'zone 2';
      }
      if (item === 'zone_3') {
        item = 'zone 3';
      }
      return item;
    });

    useTable(
      table.filter(item => {
        let pass = false;
        const statusValue = filters.map(filterValue => {
          return deepGet(item, status) === filterValue;
        });
        statusValue.map(val => {
          if (val) {
            pass = true;
          }
          return val;
        });
        if (filters.length === 0) {
          pass = true;
        }

        return pass;
      }),
    );
  }

  function HandleRadioSort(e: any): void {
    if (e.target.id === 'descendent') {
      const descendent = { one: true, two: false };
      useReverse(false);
      useRadio(descendent);
    } else if (e.target.id === 'ascendent') {
      const ascendent = { one: false, two: true };
      useReverse(true);
      useRadio(ascendent);
    }
  }

  if (visible === popup_id) {
    return (
      <SortPopUp>
        <ArrowUp />
        <RadiosContainer onChange={HandleRadioSort}>
          <Radio title="High-Low" name="tableInfo" id="descendent" checked={false} dynamicActive={radio.one} size={'21px'} />
          <Radio title="Low-High" name="tableInfo" id="ascendent" checked={false} dynamicActive={radio.two} size={'21px'} />
        </RadiosContainer>
        {includeAlerts && (
          <>
            <hr style={{ border: '0.5px solid rgba(240, 240, 240, 1)', marginBottom: '12px' }} />
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_1} onClick={() => useCheck({ ...check, zone_1: !check.zone_1 })} />
              <PopUpText onClick={() => useCheck({ ...check, zone_1: !check.zone_1 })}>Watch</PopUpText>
              <Oval size={'16'} color={'watch'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_2} onClick={() => useCheck({ ...check, zone_2: !check.zone_2 })} />
              <PopUpText onClick={() => useCheck({ ...check, zone_2: !check.zone_2 })}>Warning</PopUpText>
              <Oval size={'16'} color={'warning'} />
            </CheckBoxWrapper>
            {medical && (
              <CheckBoxWrapper>
                <InputCheckbox checked={check.zone_3} onClick={() => useCheck({ ...check, zone_3: !check.zone_3 })} />
                <PopUpText onClick={() => useCheck({ ...check, zone_3: !check.zone_3 })}>Medical</PopUpText>
                <Oval size={'16'} color={'medical'} />
              </CheckBoxWrapper>
            )}
          </>
        )}
      </SortPopUp>
    );
  } else {
    return <></>;
  }
}

export default ({
  dataTableContent,
  updateVelocity,
  filter,
}: {
  dataTableContent: Array<any>;
  updateVelocity?: any;
  filter: string;
}) => {
  const UTILS = new Utils();
  const refTable = useRef(0) as any;
  const [positionTable, setPositionTable] = useState<Object>({});

  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [popUp, usePopup] = useState<string>('');
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(true);
  const [tooltipSection, setTooltipSection] = useState<any>([ArmStrength, 'totalStrength']);
  const tooltipRef = useRef<HTMLInputElement | any>(document.createElement('div'));

  useEffect(() => {
    useTable(dataTableContent);
  }, [dataTableContent]);

  useLayoutEffect(() => {
    changeScreen();
    toggleSortDate('date', ['date'])
  }, []);

  useEffect(() => {
    window.addEventListener('resize', changeScreen);

    return () => {
      window.removeEventListener('resize', changeScreen);
    }
  }, [])

  function changeScreen() {
    setPositionTable({
      left: refTable.current.getBoundingClientRect().left,
      right: refTable.current.getBoundingClientRect().right
    })
  }

  function changeTable(e) {
    useTable([...e]);
  }
  function togglePopUp(selectedPopUp: string) {
    if (selectedPopUp === popUp) {
      usePopup('');
    } else {
      usePopup(selectedPopUp);
    }
  }

  function toggleSort(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, [!reverse, changeTable, table]);
  }

  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortDate(params, sortOptions);
  }

  function closeSorts() {
    usePopup('');
    useSort('');
  }

  function sortingTableHead(title: string = '', attr: string, location: Array<any>, sortFunction) {
    return (
      <StickyTableHeadDate topPosition="64px" topPositionResponsive="41px" onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickyTableHeadDate>
    );
  }

  function hoverOval(event, tooltipInfo) {
    let top = Number(event.clientY) + 10;
    let left = Number(event.clientX) + 10;
    if (Number(window.innerWidth) - Number(event.clientX) < 200) {
      left = Number(event.clientX) - 200;
    }
    if (Number(window.innerHeight) - Number(event.clientY) < 180) {
      top = Number(event.clientY) - 150;
    }
    tooltipRef.current.style.display = 'block';
    tooltipRef.current.style.inset = top + 'px 0px 0px ' + left + 'px';
    setTooltipSection(tooltipInfo);
  }

  function hideTooltip() {
    tooltipRef.current.style.display = 'none';
  }

  return (
    <>
      <TableUnit ref={refTable} mBottom={'40px'} minWidth={'1360px'} data-cy="keymetrics_strength">
        <TableHead>
          <TableRow>
            <TableTopHeader hide={true} colSpan={2} sticky={3}></TableTopHeader>
            <TableTopHeader colSpan={9} sticky={3}>
              STRENGTH
            </TableTopHeader>
            <TableTopHeader colSpan={7} sticky={3}>
              RECOVERY
            </TableTopHeader>
          </TableRow>
          <TableRow>
            <TableHeader colSpan={2}></TableHeader>
            <TableHeader colSpan={5} fontWeight={'normal'}>
              Arm Strength (%BW)
            </TableHeader>
            <TableHeader colSpan={1} fontWeight={'normal'}>
              Shoulder Balance
            </TableHeader>
            <TableHeader colSpan={3} fontWeight={'normal'}>
              Strength Velocity Ratio
            </TableHeader>

            <TableHeader colSpan={5}>
              Arm Recovery - <TableTopHeaderSub>{'Change from average (lbs.)'}</TableTopHeaderSub>
            </TableHeader>
          </TableRow>
          <TableRow>
            <TableSubHeader cursor={'pointer'} onClick={() => toggleSort('sortname', ['player', 'firstName'])}>
              <SortArrow>
                <span>Player name</span>
                {sort === 'sortname' && reverse && <GoChevronDown size={14} />}
                {sort === 'sortname' && !reverse && <GoChevronUp size={14} />}
              </SortArrow>
            </TableSubHeader>
            {sortingTableHead('Fresh Exam', 'date', ['date'], toggleSortDate)}
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_1')}>Arm Score</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['relativeStrength', 'total']}
                popup_id={'pu_1'}
                visible={popUp}
                includeAlerts={true}
                status={['relativeStrength', 'totalStatus']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_2')}>IR</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['relativeStrength', 'ir']}
                popup_id={'pu_2'}
                visible={popUp}
                includeAlerts={true}
                status={['relativeStrength', 'irStatus']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_3')}>ER</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['relativeStrength', 'er']}
                popup_id={'pu_3'}
                visible={popUp}
                includeAlerts={true}
                status={['relativeStrength', 'erStatus']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_4')}>Scaption</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['relativeStrength', 'scaption']}
                popup_id={'pu_4'}
                visible={popUp}
                includeAlerts={true}
                status={['relativeStrength', 'scaptionStatus']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_5')}>Grip</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['relativeStrength', 'grip']}
                popup_id={'pu_5'}
                visible={popUp}
                includeAlerts={true}
                status={['relativeStrength', 'gripStatus']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_6')}>ER:IR Ratio</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['shoulderBalance', 'erirRatio']}
                popup_id={'pu_6'}
                visible={popUp}
                includeAlerts={true}
                status={['shoulderBalance', 'erirRatioStatus']}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
            
              <span onClick={() => togglePopUp('pu_7')}> SVR </span> 
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['strengthVelocityRatio', 'svr']}
                popup_id={'pu_7'}
                visible={popUp}
                includeAlerts={true}
                status={['strengthVelocityRatio', 'status']}
              /> 
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span> Total Strength </span>
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span> Max Velocity </span>
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_9')}>Total Recovery</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armRecovery', 'total']}
                popup_id={'pu_9'}
                visible={popUp}
                includeAlerts={true}
                status={['armRecovery', 'totalStatus']}
                medical={true}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_10')}>IR</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armRecovery', 'ir']}
                popup_id={'pu_10'}
                visible={popUp}
                includeAlerts={true}
                status={['armRecovery', 'irStatus']}
                medical={true}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_11')}>ER</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armRecovery', 'er']}
                popup_id={'pu_11'}
                visible={popUp}
                includeAlerts={true}
                status={['armRecovery', 'erStatus']}
                medical={true}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_12')}>Scaption</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armRecovery', 'scaption']}
                popup_id={'pu_12'}
                visible={popUp}
                includeAlerts={true}
                status={['armRecovery', 'scaptionStatus']}
                medical={true}
              />
            </TableSubHeader>
            <TableSubHeader cursor={'pointer'}>
              <span onClick={() => togglePopUp('pu_13')}>Grip</span>
              <PopUp
                table={dataTableContent}
                useTable={changeTable}
                data={['armRecovery', 'grip']}
                popup_id={'pu_13'}
                visible={popUp}
                includeAlerts={true}
                status={['armRecovery', 'gripStatus']}
                medical={true}
              />
            </TableSubHeader>
          </TableRow>
        </TableHead>
        <TableBody onClick={() => closeSorts()}>
          {table.length ? (
            <>
              {table
                .filter(el => {
                  const playerName: string = el.player.firstName || '';
                  const playerLast: string = el.player.lastName || '';
                  const name = `${playerName} ${playerLast}`;
                  return name.toLocaleLowerCase().includes(filter.toLowerCase());
                })
                .map(item => {
                  return (
                    <TableItem
                      item={item}
                      key={item.player._id}
                      hoverInfo={hoverOval}
                      hideTooltip={hideTooltip}
                      updateVelocity={updateVelocity}
                      positionTable={positionTable}
                    />
                  );
                })}
            </>
          ) : (
            <TableRow>
              <TableColumn colSpan={20}>No data</TableColumn>
            </TableRow>
          )}
        </TableBody>
      </TableUnit>
      <TooltipFatigueZones section={tooltipSection} tooltipRef={tooltipRef} />
    </>
  );
};

const TableItem = ({ item, hoverInfo, hideTooltip, updateVelocity, positionTable }) => {
 
  const VELOCITY_MAX_VALUE = 108;
  const MARGIN_LEFT_FEATURE_LOCKED = 18;
  const MARGIN_RIGHT_FEATURE_LOCKED = 19;

  const [velocity, setVelocity] = useState<string>(parseVelocity(item.strengthVelocityRatio.velocity));
  const [svrValue, setSvrValue] = useState<string>(item.strengthVelocityRatio.svr);
  const [svrFatigueStatus, setSvrFatigueStatus] = useState<string>(item.strengthVelocityRatio.status);
  const fieldRef = useRef<HTMLInputElement | any>(document.createElement('input'));
  const [loading, setLoading] = useState<boolean>(false);

  const IRStrength = useRef(0) as any;
  const ratioStrength = useRef(0) as any;
  const IRRecoveryRef = useRef(0) as any;

  /** defines where the component should start that limits the basic functionalities */
  const [leftRecoveryLocked, setLeftRecoveryLocked] = useState<number>(0);
  const [leftStrengthLocked, setLeftStrengthLocked] = useState<number>(0);
  const [rightStrengthLocked, setRightStrengthLocked] = useState<number>(0);

  useLayoutEffect(() => {
    changeScreen();
  }, [positionTable]);

  useEffect(() => {
    window.addEventListener('resize', changeScreen);

    return () => {
      window.removeEventListener('resize', changeScreen);
    }
  }, [])

  useEffect(() => {
    setVelocity(parseVelocity(item.strengthVelocityRatio.velocity));
  }, [item]);

  const changeScreen = () => {
    setLeftStrengthLocked(IRStrength.current.getBoundingClientRect().left - positionTable.left + MARGIN_LEFT_FEATURE_LOCKED);
    setRightStrengthLocked(positionTable.right - ratioStrength.current.getBoundingClientRect().right + MARGIN_RIGHT_FEATURE_LOCKED);
    setLeftRecoveryLocked(IRRecoveryRef.current.getBoundingClientRect().left - positionTable.left + MARGIN_LEFT_FEATURE_LOCKED);
  }

  async function getField(event) {
    validateNumber(event);
    let value = event.target.value;
    if (event.key === 'Enter' && value !== '') {
      setLoading(true)
      fieldRef.current.blur();
      let response = await updateVelocity(item.player._id, value);
      if (response) {
        setLoading(false)
        let { svr, svrFatigue } = response.data.data;
        setSvrFatigueStatus(svrFatigue)
        setSvrValue(svr)
      }
    }
  }

  function validateNumber(evt) {
    var e = evt || window.event;
    var key = e.keyCode || e.which;

    if (
      (!e.shiftKey &&
        !e.altKey &&
        !e.ctrlKey &&
        // numbers
        key >= 48 &&
        key <= 57) ||
      // Numeric keypad
      (key >= 96 && key <= 105) ||
      // Backspace and Tab and Enter
      key === 8 ||
      key === 9 ||
      // Home and End
      key === 35 ||
      key === 36 ||
      // left and right arrows
      key === 37 ||
      key === 39 ||
      // Del and Ins
      key === 46 ||
      key === 45
    ) {
      // input is VALID
    } else {
      // input is INVALID
      e.returnValue = false;
      if (e.preventDefault) e.preventDefault();
    }
  }

  function limitVelocityInputLength(event, maxNum) {
    if (event.target.value.length > maxNum) {
      event.target.value = event.target.value.slice(0, maxNum);
    }

    if (event.target.value > VELOCITY_MAX_VALUE) {
      event.target.value = '  ';
      toast.error(`The max value for Velocity should be ${VELOCITY_MAX_VALUE}`);
    }
  }

  function checkInput(event) {
    if (event?.target.value <= VELOCITY_MAX_VALUE) {
      setVelocity(event?.target.value);
    }
  }

  function clearField() {
    fieldRef.current.value = '';
    setVelocity('');
  }

  function parseVelocity(vel) {
    if (Number(vel)) {
      return String(Number(vel).toFixed(0));
    }
    return '';
  }

  return (
    <TableRow style={{ position: 'relative' }}>
      <TableColumn bgColor={'white'}>
        <SelectPlayerColumn player={item.player} unClickeable={item.player.plan === 'basic'} cursor={'pointer'} />
      </TableColumn>
      <TableColumn bgColor={'white'}>{handleDate(item.date)}</TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.relativeStrength.total, { digits: 0 })}
        {getFatigueZoneBullet(item.relativeStrength.totalStatus, [
          hoverInfo,
          [ArmStrength, 'totalStrength', 'Total Strength'],
          hideTooltip,
        ])}
      </TableColumn>
      <TableColumn ref={IRStrength}>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.relativeStrength.ir, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.relativeStrength.irStatus, [hoverInfo, [ArmStrength, 'iR', 'Internal Rotation'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.relativeStrength.er, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.relativeStrength.erStatus, [hoverInfo, [ArmStrength, 'eR', 'External Rotation'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.relativeStrength.scaption, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.relativeStrength.scaptionStatus, [hoverInfo, [ArmStrength, 'scaption', 'Scaption'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.relativeStrength.grip, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.relativeStrength.gripStatus, [hoverInfo, [ArmStrength, 'grip', 'Grip'], hideTooltip])}
      </TableColumn>
      <TableColumn ref={ratioStrength} bgColor={'white'}>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.shoulderBalance.erirRatio, { digits: 2 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.shoulderBalance.erirRatioStatus, [
          hoverInfo,
          [ShoulderBalance, 'shoulderBalance', 'Shoulder Balance'],
          hideTooltip,
        ])}
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(svrValue, { digits: 1 })}
        {getFatigueZoneBullet(svrFatigueStatus, [
          hoverInfo,
          [StrengthVelocityRatio, 'velocity', 'Total Strength / Velocity'],
          hideTooltip,
        ])}
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.strengthVelocityRatio.totalStrength, { digits: 1 })}
      </TableColumn>
      <TableColumn>
        <InputErasableContainer width={'100px'} mWidth={'100px'} backgroundColor={'white'}>
          {loading ? (
            <>
              <Loader height="10px" width="10px" />
            </>
          ) : (
            <>
              <InputErasableField
                ref={fieldRef}
                placeholder="Enter Velocity"
                defaultValue={velocity}
                onKeyDown={getField}
                onInput={event => {
                  limitVelocityInputLength(event, 3);
                }}
                onChange={event => checkInput(event)}
                autoComplete={'nope'}
              />
              {velocity && (
                <>
                  <InputErasableDelete onClick={clearField}>x</InputErasableDelete>
                </>
              )}
            </>
          )}
        </InputErasableContainer>
      </TableColumn>
      <TableColumn>
        {numberColumnFormatter(item.armRecovery.total, { digits: 1 })}
        {getFatigueZoneBullet(item.armRecovery.totalStatus, [hoverInfo, [ArmRecovery, 'totalStrength', 'Total Strength'], hideTooltip])}
      </TableColumn>
      <TableColumn ref={IRRecoveryRef}>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.armRecovery.ir, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.armRecovery.irStatus, [hoverInfo, [ArmRecovery, 'iR', 'Internal Rotation'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.armRecovery.er, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.armRecovery.erStatus, [hoverInfo, [ArmRecovery, 'eR', 'External Rotation'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.armRecovery.scaption, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.armRecovery.scaptionStatus, [hoverInfo, [ArmRecovery, 'scaption', 'Scaption'], hideTooltip])}
      </TableColumn>
      <TableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.armRecovery.grip, { digits: 1 })}
        {item.player.plan !== 'basic' && getFatigueZoneBullet(item.armRecovery.gripStatus, [hoverInfo, [ArmRecovery, 'grip', 'Grip'], hideTooltip])}
      </TableColumn>
      {item.player.plan === 'basic' && (
        <>
          {/*Strength feature locked*/}
          <FeatureLocked left={leftStrengthLocked} right={rightStrengthLocked}>
            <TitleFeatureLocked>Basic Subscription</TitleFeatureLocked>
          </FeatureLocked>
          {/*Recovery feature locked*/}
          <FeatureLocked left={leftRecoveryLocked} right={19}>
            <TitleFeatureLocked>Basic Subscription</TitleFeatureLocked>
          </FeatureLocked>
        </>
      )}
    </TableRow>
  );
};
